import { Component, OnInit, Input } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { APIService } from '../../api.service';

@Component({
  selector: 'app-select-job',
  templateUrl: './select-job.component.html',
  styleUrls: ['./select-job.component.scss']
})
export class SelectJobComponent implements OnInit {

  @Input() WIPNo: number = 0;
  @Input() mdlRef: any;

  wip = {
    id: 0,
    name: ''
  } 
  WIPNos: any = [];
  jarvisData: any = [];
  agencyData:any = [];

  constructor(public activeModal: NgbActiveModal, private apiService: APIService) { }

  ngOnInit(): void {

    let agencyData = this.apiService.getCookie("M");
    if (agencyData) {
      this.agencyData = JSON.parse(agencyData);
    }
  
    var jarvis = this.apiService.getCookie("Jarvis");
    if (jarvis) {
      this.jarvisData = JSON.parse(jarvis);
    }

    if (this.WIPNo > 0) {
      this.wip.id = this.WIPNo;
    }

    this.getWIPNos();
  }
 
  getWIPNos() {
    //this.WIPNos = ['001', '002', '003', '004', '005', '006', '007', '008', '009', '010'];

    let data = [{
      statusID: 1,
      month: 1,
      year: 2021
    }];

    let myParams = [{
      myUserID: this.jarvisData[0].UserID,
      myToken: this.jarvisData[0].WebToken,
      forAgencyID: this.jarvisData[0].AgencyIDs,
      myAgencyIDs: this.jarvisData[0].AgencyIDs,
      ForERPAgencyID: this.agencyData[0].ERPAgencyID,
      myLastSyncDT: null,
      isWeb: true,
      actionType: 'getPrdJobs',
      moduleID: 8,
      data: JSON.stringify(data)
    }];
    
    this.apiService.getData(myParams, this.successConfigResp.bind(this), this.failureResp.bind(this));
  }

  //successConfigResp - success  get handler
  successConfigResp(res: any) {
    if (res.error) {
    }
    else {
      if (res) {
        var reponseData = JSON.parse(res.updatePackage);
        if (reponseData) {
          let cData = reponseData.Table1;
          this.WIPNos = cData;
        }
      }
    }
  }

  //failureResp - failure handler
  failureResp(res: any) {
    if (res.error) {
    }
    else {
      this.apiService.successAlert(res.message);
    }
  }

  passBack() {
    this.mdlRef.close();
  }

  save() {
    if (this.wip.id == 0) {
      this.apiService.successAlert('Please select WIP No.');
      return;
    }
    else {
      let tmpWIPNo = this.WIPNos.filter((a: any) => a.JobID == this.wip.id);
      this.mdlRef.close(tmpWIPNo);
    }
    
  }

}
